import { route } from '@/ziggy-shim';
import { api, CastValue } from './LaravelClient';

export default {
  async store(projectId: Id, packageId: Id, data: ApiRequests['api.v1.scope-gap-items.store']) {
    return await api(route('api.v1.scope-gap-items.store', { project: projectId, package: packageId }), 'post', {
      data,
    });
  },

  async update(id: Id, data: ApiRequests['api.v1.scope-gap-items.update']) {
    return await api(route('api.v1.scope-gap-items.update', id), 'patch', {
      data,
      casts: {
        final_amount: (value, clone, key) => new CastValue(value).cast('nullable', clone, key).get(),
        scope_gap_category_id: (value, clone, key) => new CastValue(value).cast('nullable', clone, key).get(),
      },
    });
  },
};
